import React, { useEffect, useRef, useState } from "react";
import {
  Spa as SpaIcon,
  ArrowDownward as ArrowDownwardIcon,
  Close as CloseIcon,
} from "@material-ui/icons";

import { SERVICOS_SECTION_ID, scrollToServicos } from "./ServicosAbraCasa";
import styles from "./ServicosTeaser.module.css";

const DISMISS_KEY = "servicosFloatingDismissed";

function ServicosTeaser() {
  const teaserRef = useRef<HTMLButtonElement>(null);
  const [teaserVisible, setTeaserVisible] = useState(true);
  const [sectionReached, setSectionReached] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === "true"
  );

  useEffect(() => {
    const teaser = teaserRef.current;
    const section = document.getElementById(SERVICOS_SECTION_ID);
    if (!teaser || !section || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === teaser) setTeaserVisible(entry.isIntersecting);
        if (entry.target === section) {
          setSectionReached(entry.isIntersecting || entry.boundingClientRect.top < 0);
        }
      });
    });

    observer.observe(teaser);
    observer.observe(section);

    const onScroll = () => {
      if (window.pageYOffset > 200) {
        setHasScrolled(true);
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  const showFloating = hasScrolled && !teaserVisible && !sectionReached && !dismissed;

  return (
    <>
      <button ref={teaserRef} type="button" className={styles.teaser} onClick={scrollToServicos}>
        <span className={styles.teaserIcon}>
          <SpaIcon />
        </span>
        <span className={styles.teaserText}>
          <strong>Novo:</strong> impermeabilização, higienização e montagem para os móveis que você já tem
        </span>
        <span className={styles.teaserLink}>
          Conhecer <ArrowDownwardIcon />
        </span>
      </button>

      <div
        className={`${styles.floating} ${showFloating ? styles.floatingVisible : ""}`}
        aria-hidden={!showFloating}
      >
        <button
          type="button"
          className={styles.floatingMain}
          onClick={scrollToServicos}
          tabIndex={showFloating ? 0 : -1}
        >
          <SpaIcon />
          Cuidados para seus móveis
        </button>
        <button
          type="button"
          className={styles.floatingClose}
          onClick={dismiss}
          aria-label="Dispensar"
          tabIndex={showFloating ? 0 : -1}
        >
          <CloseIcon />
        </button>
      </div>
    </>
  );
}

export default ServicosTeaser;
